// src/components/QuickSearch/primitives/KeyboardHint.tsx
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardReturn as KeyboardReturnIcon,
} from '@mui/icons-material'
import { Chip } from '@mui/material'
import React from 'react'

type IconString = '↑' | '↓' | '↵' | 'ArrowUp' | 'ArrowDown' | 'Enter' | 'Return';

interface KeyboardHintProps {
  icon?: React.ReactElement | IconString;
  label?: string;
  size?: 'small' | 'medium';
  variant?: 'outlined' | 'filled';
}

export default function KeyboardHint(props: KeyboardHintProps): JSX.Element {
  const {
    icon,
    label,
    size = 'small',
    variant = 'outlined',
  } = props

  const renderedIcon = React.useMemo((): React.ReactElement | undefined => {
    if (!icon) {
      return undefined
    }

    if (typeof icon === 'string') {
      switch (icon) {
        case '↑':
        case 'ArrowUp':
          return <KeyboardArrowUpIcon />
        case '↓':
        case 'ArrowDown':
          return <KeyboardArrowDownIcon />
        case '↵':
        case 'Enter':
        case 'Return':
          return <KeyboardReturnIcon />
        default:
          return undefined
      }
    }
    return icon
  }, [icon])

  return (
    <Chip
      icon={renderedIcon}
      label={capitalizeFirstLetter(label)}
      size={size}
      variant={variant}
    />
  )
}

function capitalizeFirstLetter(label?: string): string {
  if (!label) {
    return ''
  }

  return label.charAt(0).toUpperCase() + label.slice(1)
}
